import { ChangeDetectionStrategy, Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
    selector: 'app-login-failed',
    template: `
    <div class="text-center mt-3 mb-5">
      <h2>LOGIN FAILED</h2>
      <p class="mx-auto text-center">
        We are sorry, we had trouble logging you in with the username/password you provided.
        Please go back to the home page, or contact us at <a href="mailto:customercare@southwesternadvantage.com" class="contact font-weight-bold">customercare&#64;southwesternadvantage.com</a></p>
      <div class="mt-4 mb-5">
        <a [routerLink]="[dashboardUri]" class="btn btn-large btn-primary">GO TO HOMEPAGE</a>
      </div>
    </div>
  `,
    styles: [`
      h2 {
        font-size: 40px;
        font-weight: 700;
        color: blue;
      }
      p { max-width: 400px; }
      a.contact, a.contact:hover, a.contact:focus, a.contact:visited {
        color: #029edb;
        text-decoration: none;
      }
  `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink]
})

export class LoginFailedComponent {
   /* SITE_DIRECTORY_ROUTES.uri is already '/' - prefixing another '/' makes '//' */
   dashboardUri = SITE_DIRECTORY_ROUTES.uri
}
